module.exports = __webpack_public_path__ + "img/mitaofei.ebce0e4b.png";